import { axiosInstance } from '@/config/axios.config';
import {
  CreateFoodSupplementRequest,
  FoodSupplement,
  PaginatedFoodSupplementsResponse,
  UpdateFoodSupplementRequest,
} from '@repo/types/src/food-supplement';

export const getAllFoodSupplements = async (params?: {
  skip?: number;
  take?: number;
}) => {
  const queryParams = new URLSearchParams();
  if (params?.skip !== undefined)
    queryParams.append('skip', params.skip.toString());
  if (params?.take !== undefined)
    queryParams.append('take', params.take.toString());
  const url = `/food-supplements${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
  const response =
    await axiosInstance.get<PaginatedFoodSupplementsResponse>(url);
  return response.data;
};

export const getFoodSupplementById = async (id: number) => {
  const response = await axiosInstance.get<FoodSupplement>(
    `/food-supplements/${id}`,
  );
  return response.data;
};

export const createFoodSupplement = async (
  payload: CreateFoodSupplementRequest,
) => {
  const response = await axiosInstance.post<FoodSupplement>(
    '/food-supplements',
    payload,
  );
  return response.data;
};

export const updateFoodSupplement = async (
  id: number,
  payload: UpdateFoodSupplementRequest,
) => {
  const response = await axiosInstance.patch<FoodSupplement>(
    `/food-supplements/${id}`,
    payload,
  );
  return response.data;
};

export const deleteFoodSupplement = async (id: number) => {
  const response = await axiosInstance.delete<FoodSupplement>(
    `/food-supplements/${id}`,
  );
  return response.data;
};
